export type ThemeMode = 'light' | 'dark';

/**
 * Theme is driven by CSS variables defined in src/index.css under :root and html.dark.
 * Toggling the dark mode is just toggling the .dark class on <html>; no JS-side
 * variable patching is needed for the colour palette itself.
 */
export function applyTheme(mode: ThemeMode): void {
  document.documentElement.classList.toggle('dark', mode === 'dark');
}
